import React from 'react';
import { CalendarHeart, MessageCircle, Search, UserPlus } from 'lucide-react';
import './StepsRow.css';

const STEPS = [
    { icon: UserPlus, title: 'Create your profile', text: 'Sign up free in minutes with your family details and preferences.' },
    { icon: Search, title: 'Discover verified matches', text: 'Browse genuine profiles that fit your values, community and horoscope.' },
    { icon: MessageCircle, title: 'Connect with families', text: 'Send interest and chat privately once both sides are comfortable.' },
    { icon: CalendarHeart, title: 'Plan your celebration', text: 'Book trusted photographers, caterers, halls and more in one place.' },
];

// "Simple steps to find your life partner": four steps in a row, joined by a dotted line.
const StepsRow = () => (
    <section className="steps-row" aria-labelledby="steps-row-title">
        <div className="steps-row__inner">
            <p className="steps-row__eyebrow">Your journey starts here</p>
            <h2 id="steps-row-title">Simple Steps to Find Your <em>Life Partner</em></h2>

            <ol className="steps-row__list">
                {STEPS.map((step, index) => (
                    <li key={step.title}>
                        <span className="steps-row__icon">
                            <step.icon size={30} strokeWidth={1.5} />
                            <b>{String(index + 1).padStart(2, '0')}</b>
                        </span>
                        <h3>{step.title}</h3>
                        <p>{step.text}</p>
                    </li>
                ))}
            </ol>
        </div>
    </section>
);

export default StepsRow;
